export const CHART_HEIGHT = document.documentElement.clientHeight / 3

export const SIDEBAR_WIDTH = {
  200: 200,
  240: 240,
  300: 300,
  400: 400,
}
